// DiffView — mostra no celular o que um write_file vai gravar (arquivo +
// conteúdo proposto). O gate de aprovação (approval_request/decision) já corre
// em paralelo pelo runner; aqui é a visualização. (Diff verdadeiro antes/depois
// exige o conteúdo antigo — deferido, ver DECISIONS D-V2-007.)

export default function DiffView({ file, content, patch }) {
  return (
    <div className="flex flex-col gap-1 rounded-md border border-apolo-borderSubtle bg-apolo-surface2 p-2">
      <p className="text-xs font-medium text-apolo-textSecondary">{file || '(arquivo)'}</p>
      <pre className="max-h-60 overflow-auto whitespace-pre-wrap break-words rounded bg-apolo-bg p-2 text-xs text-apolo-textTertiary">
        {patch || content || ''}
      </pre>
    </div>
  );
}
